export const LOAD_ASK_DEMOS = 'LOAD_ASK_DEMOS'
export const LOAD_ASK_DEMO_STATUS = 'LOAD_ASK_DEMO_STATUS'